import router from './router/router';
import store from './store';
//没有登录时可以直接访问的页面
const whiteList = [
  '/404',
  '/401',
  '/lock',
  '/login',
  '/register',
  '/biz/payroll',
  '/emailConfirm',
  '/loginWeb',
  '/ciicWeb',
  '/loginOld',
  '/loginOldV2',
  '/cancelSubscribe',
  '/receipt/verification'
];
import { validatenull } from '@/util/validate';
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    store.dispatch('ClearCache');
  }
  if (store.getters.accessToken) {
    const { isUpdatePwdTips, isInitPwd } = store.getters.userInfo;
    const { pms, permissionAddRoutes } = store.getters;
    if (whiteList.indexOf(to.path) == -1 || (to.path != null && to.path.indexOf('/t/') == 0) ) {
      if (isUpdatePwdTips === true || isInitPwd === true){
        next('/login');
      } else {
        if (validatenull(permissionAddRoutes)) {
          const menuSet = pms[1].map(item => {
            return item.operateCode;
          })
          store.dispatch('permission/generateRoutes', menuSet).then(accessRoutes => {
            const routes = [
              ...accessRoutes,
              {
                path: '*',
                redirect: '/404',
                hidden: true
              }
            ]
            router.addRoutes(routes)
          })
        }
        next();
      }
    } else {
      next();
    }
  } else {
    if (
      whiteList.indexOf(to.path) !== -1 ||
      (to.path != null && to.path.indexOf('/t/') == 0) ||
      (to.path != null && to.path.indexOf('/mobile/') == 0)
    ) {
      next();
    } else {
      next('/login')
    }
  }
});
